import * as React from 'react';
import type {
  IDropDownMenuProps,
  IDropDownMenuImperativeActions,
} from '../../../DropDownMenu.types';
import DropDownMenuBase from '../../DropDownMenuBase';
import type { MenuButtonProps } from '../../../../MenuButton/MenuButton.types';

type LinesMenuButtonProps = IDropDownMenuProps & {
  styles: any;
  Button: React.FC<MenuButtonProps>;
};

const LinesMenuButton: React.ForwardRefRenderFunction<
  IDropDownMenuImperativeActions,
  LinesMenuButtonProps
> = (props, ref) => {
  const { styles, Button } = props;
  return (
    <DropDownMenuBase {...props} ref={ref} styles={styles} Button={Button} />
  );
};

export default React.forwardRef(LinesMenuButton);
